import {Link} from '@reach/router'
import {withStyle} from '../style'

export default withStyle(Link)
